module.exports = __webpack_public_path__ + "static/media/cartaocidadao.82e8a571.jpg";